import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card, Form, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import swal from "sweetalert";

const AddServices = () => {
  const [servicesList, setServicesList] = useState([]);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm();
  const onSubmit = (data) => {
    const serviceData = new FormData();
    serviceData.append("name", data?.name);
    serviceData.append("price", data?.price);
    serviceData.append("description", data?.description);
    serviceData.append("image", data?.image[0]);
    addServiceHandler(serviceData);
  };

  const token = JSON.parse(localStorage.getItem("user"));

  const addServiceHandler = (serviceData) => {
    axios
      .post("https://mysterious-sierra-48850.herokuapp.com/addService", serviceData, {
        headers: {
          "Content-Type": "multipart/form-data",
          authorization: "Bearer " + token.token,
        },
      })
      .then((data) => {
        console.log(data.data);
        if (data.data.success) {
          getServicesHandler();
          swal({
            title: "Good job!",
            text: data?.data?.message,
            icon: "success",
            button: "Aww yiss!",
          });
          reset();
        }
      })
      .catch((error) => console.log(error.response));
  };

  const getServicesHandler = () => {
    axios
      .get("https://mysterious-sierra-48850.herokuapp.com/get-services", {
        headers: {
          "Content-Type": "multipart/form-data",
          authorization: "Bearer " + token.token,
        },
      })
      .then((data) => {
        setServicesList(data.data);
      })
      .catch((error) => console.log(error.response));
  };

  const deleteServiceHandler = (_id) => {
    axios
      .delete(`https://mysterious-sierra-48850.herokuapp.com/deleteService/${_id}`, {
        headers: {
          "Content-Type": "multipart/form-data",
          authorization: "Bearer " + token.token,
        },
      })
      .then((data) => {
        if (data.data.success) {
          console.log(data.data);
          getServicesHandler();
          getServicesHandler();
          swal({
            title: "Good job!",
            text: data?.data?.message,
            icon: "success",
            button: "Aww yiss!",
          });
        }
      });
  };

  useEffect(() => {
    getServicesHandler();
  }, []);

  return (
    <section>
      <div className="d-flex justify-content-center">
        <Card className="m-3" style={{ width: "100vh", maxWidth: "760px" }}>
          <Card.Title className="text-center pt-3">Add Service</Card.Title>
          <Card.Body>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Form.Group controlId="name">
                <Form.Label>Service Name</Form.Label>
                <Form.Control {...register("name", { required: true })} />
              </Form.Group>

              <Form.Group controlId="price">
                <Form.Label>Service Price</Form.Label>
                <Form.Control {...register("price", { required: true })} />
              </Form.Group>

              <Form.Group controlId="description">
                <Form.Label>Service Description</Form.Label>
                <Form.Control
                  {...register("description", { required: true })}
                />
              </Form.Group>

              <Form.Group controlId="image">
                <Form.Label>Service Image</Form.Label>
                <Form.Control
                  type="file"
                  {...register("image", { required: true })}
                />
              </Form.Group>
              <Button type="submit">Add Now</Button>
            </Form>
          </Card.Body>
        </Card>
      </div>
      {/* services list start */}
      <Card>
        <Card.Title className="text-center mt-2">Service List</Card.Title>
        <Card.Body className="d-flex flex-wrap justify-content-center">
          {servicesList.map((service) => {
            return (
              <Card
                className="text-center"
                style={{ maxWidth: "360px" }}
                key={service._id}
              >
                <Card.Img
                  style={{ maxHeight: "200px" }}
                  className=""
                  variant="top"
                  src="https://i.ibb.co/RSbfzf7/4-190687129806558e-27.jpg"
                />
                <Card.Title>{service?.name}</Card.Title>
                <Card.Body>
                  <Card.Text>Price: {service?.price}</Card.Text>
                  <Card.Text>{service?.description}</Card.Text>
                  <Button
                    variant="danger"
                    onClick={() => deleteServiceHandler(service?._id)}
                  >
                    Remove
                  </Button>
                </Card.Body>
              </Card>
            );
          })}
        </Card.Body>
      </Card>
    </section>
  );
};

export default AddServices;

/****
 *  <Card className="text-center" style={{ maxWidth: "360px" }}>
            <Card.Img
              style={{ maxHeight: "200px" }}
              className=""
              variant="top"
              src="https://i.ibb.co/RSbfzf7/4-190687129806558e-27.jpg"
            />
            <Card.Title>Service 1</Card.Title>
            <Card.Body>
              Lorem ipsum dolor sit amet consectetur, adipisicing elit.
              Voluptatibus, quas?
            </Card.Body>
          </Card>
 */
